import { render, staticRenderFns } from "./enterBox.vue?vue&type=template&id=1cf3c132&scoped=true&"
import script from "./enterBox.vue?vue&type=script&lang=js&"
export * from "./enterBox.vue?vue&type=script&lang=js&"
import style0 from "./enterBox.vue?vue&type=style&index=0&id=1cf3c132&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf3c132",
  null
  
)

export default component.exports